/**
 * Created by akirilyuk on 2/12/2016
 */
define(function (require) {
    "use strict";

    var KPSnippetView = require("connection-views/KPsTab/KPSnippetView");
    var DomUtilities = require("infra-util/DomUtilities");
    var Template = require("connection-templates/ticketTab/ArticleSuggestionsView.tmpl");
    var NoResultsView = require("connection-views/KPsTab/NoResultsView");
    var LoadingView = require("connection-views/ticketTab/ArticleSuggestionsLoadingView");
    var KPsSearchResultsCollection = require("connection-collections/KPsTab/KPsSearchResultsCollection");
    var ArticleSuggestionRowView = require("connection-views/ticketTab/ArticleSuggestionRowView");

    var ArticleSuggestionsView = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ArticleSuggestionsView = Marionette.CompositeView.extend({
            itemView: ArticleSuggestionRowView,
            itemViewContainer: ".results-container",
            template: Template,
            emptyView: LoadingView,
            className: "article-suggestion-view",
            ui:{
                content: ".results-container"
            },
            initialize: function (options) {
                this.container = options.el;
                this.connectionPanelContextModel = options.context;
                this.collection = new Backbone.Collection();
                this._transitionSupport = DomUtilities.isTransitionSupported();
                this.loaded = false;
            },

            onRender: function () {
                this.container.append(this.el);
                this.$el.addClass("hide");
                this.hideView();
            },

            unhideView: function(){
                this.$el.removeClass("hide");
                var that = this;
                _.delay(function(){
                    $(that.ui.content).css("opacity",1);
                },1);
            },

            hideView: function(){
                var that =this;
                _.delay(function(){
                    $(that.ui.content).css("opacity",0);
                },1);
                _.delay(function(){
                    that.$el.addClass("hide");
                },300);
                this.collection.reset();
            },

            isHidden: function () {
                return this.$el.hasClass("hide");
            },

            setLoader: function(){
                this.emptyView = LoadingView;
                this._resetWithTransition();
            },

            _resetWithTransition: function(collection){
                if(this._transitionSupport){
                    var that = this;
                    _.delay(function(){
                        $(that.ui.content).css("opacity",0);
                    },1);
                    _.delay(function(){
                        that.collection.reset(collection);
                    },300);
                    _.delay(function(){
                        $(that.ui.content).css("opacity",1);
                    },300);
                }else{
                    this.collection.reset(collection);
                }
            },

            setCollection: function(_collection){
                var collection = new Backbone.Collection(_collection.slice(0,4));
                this.loaded = true;
                this.emptyView = NoResultsView;
                var grid = collection.groupBy(function(list,iterator){
                    return Math.floor(iterator/ 2);
                });
                this._resetWithTransition(_.toArray(grid));
            }

        });
    });

    return ArticleSuggestionsView;


});

